import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { TemperatureReadings_ModuleContextService } from './TemperatureReadings.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class TemperatureReadings_temperature_reading_points_ComponentContextService {
  private readonly moduleContext: TemperatureReadings_ModuleContextService;

  constructor(moduleContext: TemperatureReadings_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'temperature_reading_points',
      type: ComponentType.selector
    }
  }
}